



















import {Component, Vue, Prop} from "vue-property-decorator";
import {getWeekNumber} from "element-ui/src/utils/date-util";

@Component
export default class DateRangePicker extends Vue {
    @Prop(String) private beginDate!: string|null;
    @Prop(String) private endDate!: string|null;
    @Prop(String) private format!: string|undefined ;
    @Prop(String) private valueFormat!: string|undefined;
    @Prop(Boolean) private disabled!: boolean;
    @Prop(Boolean) private readonly !: boolean;

    get value(): string[] {
        return [this.beginDate ? this.beginDate : "", this.endDate ? this.endDate : ""];
    }

    set value(dates: string[]) {
        this.$emit("begin-date-changed", {value: dates[0]});
        this.$emit("end-date-changed", {value: dates[1]});
    }

    private get pickerOptions() {
        return {
            firstDayOfWeek: 1,
            cellClassName(date: Date) {
                if (date.getDay() === 1) {
                    return "week-number-" + getWeekNumber(date);
                }
            },
        };
    }
}
